import classnames from 'classnames';
import { useResize } from 'components/hooks/useResize';
import ErrorBoundary from 'components/ui/ErrorBoundary';
import MobileBottomMenu from 'components/ui/MobileBottomMenu';
import { useAppContext } from 'context/state';
import { useUserContext } from 'context/user_state';
import Head from 'next/head';
import { useRouter } from 'next/router';
import { useInsertionEffect, useRef } from 'react';
import { SalesBanners } from 'types/enums';
import Footer from '../Footer';
import styles from './index.module.scss';

interface Props {
  title?: string;
  description?: string;
  children: React.JSX.Element | React.JSX.Element[];
  withFooter?: boolean;
  disabledNavBar?: boolean;
  hideMobileHeader?: boolean;
  withMobileMenu?: boolean;
  isMobile?: boolean;
  disablePaddings?: boolean;
  withoutPaddingBottom?: boolean;
  centered?: boolean;
}

export default function ContentLayout(props: Props) {
  const appContext = useAppContext();
  const { isTabletWidth } = useResize();
  const wrapperRef = useRef<HTMLDivElement>(null);

  const router = useRouter();
  const userContext = useUserContext();

  useInsertionEffect(() => {
    if ((isTabletWidth || props.isMobile) && props.hideMobileHeader) {
      appContext.setHideHeader(true);
    } else {
      appContext.setHideHeader(false);
    }
  }, [isTabletWidth, props.isMobile]);

  const isShowBanner =
    appContext?.banners &&
    appContext?.banners?.find(
      (el) => el.position.toUpperCase() === SalesBanners.Top.toUpperCase(),
    ) &&
    userContext.isLogged;

  return (
    <>
      {props.title && (
        <Head>
          <title>{`ArbiHunter | ${props.title}`}</title>
          <meta name='description' content={props.description || props.title} />
        </Head>
      )}
      <div
        ref={wrapperRef}
        className={classnames(
          styles.wrapper,
          props.withMobileMenu && isTabletWidth && styles.withMobileMenu,
          !props.withFooter && !props.withoutPaddingBottom && styles.withoutFooter,
          {
            [styles.wrapper__withMarginTop]: isShowBanner,
            [styles.wrapper__withMarginTop__hideMobileHeader]:
              isShowBanner && props.hideMobileHeader,
            [styles.wrapper__withMarginTop__mainPage]: isShowBanner && router.pathname === '/',
          },
        )}>
        <div
          className={classnames({
            [styles.disabledNavBar]: props.disabledNavBar,
            [styles.centered]: props.centered,
            contentWrapper: !props.disablePaddings,
          })}>
          <ErrorBoundary>{props.children}</ErrorBoundary>
        </div>
        {props.withFooter && !appContext.size.isTabletWidth ? <Footer /> : null}
        {props.withMobileMenu && isTabletWidth && <MobileBottomMenu />}
      </div>
    </>
  );
}
